export const CHANGE_THEME = 'ui/CHANGE_THEME'

export const changeTheme = theme => ({
  type: CHANGE_THEME,
  theme,
})
